import { Pagination } from "@elastic/eui";
import {
  Box,
  Button,
  Flex,
  Group,
  LoadingOverlay,
  Select,
  Text,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  isNullOrEmpty,
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../../_base/extension/StringExtension";
import Repository from "../../../../_base/helper/HttpHelper";
import { paginationBase } from "../../../../_base/model/_base/BaseTable";
import {
  getListTechnicalCommon,
  handleEditProductTechnicalNew,
} from "../../../../api/ApiProduct";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import { useDisclosure } from "@mantine/hooks";

interface dataOptionType {
  value: string;
  label: string;
  disabled?: boolean;
}

const ItemTechnicalCommonCommand = () => {
  const { dataItemTechnical, setDataItemTechnical } = useProductCreateStore();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);

  const [loading, setLoading] = useState(false);
  const [toltal, setTotal] = useState(0);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<Pagination>(paginationBase);

  const [dataOption, setDataOption] = useState<dataOptionType[]>([]); //dùng để làm options cho select
  const [listTechnical, setListTechnical] = useState<any[]>([]);
  const [visible, { open, close, toggle }] = useDisclosure(false);

  const loadDataCategory = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    setLoading(true);
    setListTechnical([]);
    setError(undefined);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `?Skip=${index * (size ?? 0)}&Take=${size}`;
      if (!isNullOrEmpty(keyWord))
        urlSearch = urlSearch + `&KeySearch=` + keyWord;
      if (!isNullOrUndefined(inActive))
        urlSearch = urlSearch + `&Active=` + inActive;
      let callapi = await getListTechnicalCommon(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setTotal(0);
      } else {
        // cập nhật list option thông số luôn
        setListTechnical(callapi?.data ?? []);
        const dataOption = callapi?.data?.map((item: any) => {
          return {
            value: item.id.toString(),
            label: item.techComName
              ? item.techComName.replace(/\t/g, "").trim()
              : "", // Kiểm tra `techComName` trước khi xử lý
          };
        });
        setDataOption(dataOption);

        setPagination({
          ...pagination,
          totalItemCount: callapi?.totalCount ?? 0,
        });
        setTotal(callapi?.totalCount ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
    }
  };

  const getDetailById = (valueSelect: string) => {
    return listTechnical?.find((item: any) => {
      return item?.id == valueSelect;
    });
  };

  const handleAddSelect = () => {
    setDataItemTechnical([...dataItemTechnical, {}]);
  };
  const handleChangeProvince = (value: string, index: number) => {
    // console.log("value", value);
    // console.log("index", index);
    // Xử lý sự kiện khi giá trị của ô Select thay đổi
    const item = getDetailById(value);
    console.log("item", item);
    const data = [...dataItemTechnical];
    data[index] = {
      itemTecCode: item?.techComCode,
      itemTecName: item?.techComName?.replace(/\t/g, "").trim(), // Loại bỏ ký tự tab và khoảng trắng dư thừa
      description: item?.description,
      orgId: item?.orgId,
      technicalCommonId: item?.id,
      creationDate: item?.creationDate,
      lastUpdateDate: item?.lastUpdateDate,
      lastUpdatedBy: item?.lastUpdatedBy,
      lastUpdateLogin: item?.lastUpdateLogin,
      createdBy: item?.createdBy,
      id: item?.id || 0, // ID mới sẽ được tạo khi lưu
      invItemId: dataItemBase?.id,
    };
    setDataItemTechnical(data);
  };
  // console.log("dataBase", dataItemBase);
  const handleRemoveSelect = (index: number) => {
    const newDataItemTechnical = [...dataItemTechnical];
    newDataItemTechnical.splice(index, 1);
    setDataItemTechnical(newDataItemTechnical);
  };

  const handleSubmitForm = async () => {
    try {
      open();
      // console.log("dataItemTechnical", dataItemTechnical);
      const response = await handleEditProductTechnicalNew(dataItemTechnical);
      if (response && response.success) {
        NotificationExtension.Success("Cập nhật dữ liệu thành công");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };

  // console.log("dataOption", dataOption);
  // console.log("listTechnical", listTechnical);
  useEffect(() => {
    loadDataCategory(pagination.pageIndex, pagination.pageSize);
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    setDataOption((prevDataOption) => {
      const updatedDataOptions = prevDataOption.map((option) => {
        const isOptionSelected = dataItemTechnical.some(
          (item) => item.technicalCommonId?.toString() === option.value
        );
        return { ...option, disabled: isOptionSelected };
      });

      return updatedDataOptions;
    });
  }, [dataItemTechnical]);

  return (
    <Box
      className="flex-none"
      component="form"
      miw={1300}
      maw={1400}
      mx="auto"
      style={{ position: "relative" }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Text mt={12} fw={600}>
        Bảng thông số kỹ thuật
      </Text>
      <Flex direction={"row"} align={"center"} gap={12}>
        {dataItemTechnical?.length === 0 ? (
          <Text fw={400}>
            Sản phẩm chưa có nhóm thông số kỹ thuật nào. Hãy Chọn nhóm cho sản
            phẩm này
          </Text>
        ) : (
          <Text fw={400}>
            Nhóm thông số kỹ thuật sẽ được hiển thị trên trang chi tiết sản phẩm
          </Text>
        )}

        <Button type="button" color="#3598dc" onClick={handleAddSelect}>
          Thêm nhóm thông số KT
        </Button>
      </Flex>

      {dataItemTechnical?.map((_, index) => (
        <Group key={index} grow wrap="nowrap" mt="xs" gap={"lg"}>
          <Select
            mt={"lg"}
            label={`Chọn danh mục ${index + 1}`}
            placeholder="Danh mục"
            data={dataOption}
            searchable
            withAsterisk
            onChange={(value) => handleChangeProvince(value!, index)}
            value={dataItemTechnical[index]?.technicalCommonId?.toString()}
            mb={"lg"}
          />
          <Button
            mt={"lg"}
            style={{ maxWidth: 80 }}
            type="button"
            color="red"
            onClick={() => handleRemoveSelect(index)}
          >
            Xóa
          </Button>
        </Group>
      ))}

      <Group
        justify="flex-end"
        mt="lg"
        p="10px 0"
        style={{ position: "sticky", bottom: 10, backgroundColor: "white" }}
      >
        <Button
          type="button"
          color="#3598dc"
          onClick={(e) => {
            handleSubmitForm();
          }}
          leftSection={<IconCheck size={18} />}
        >
          Lưu
        </Button>
        <Button
          variant="outline"
          color="black"
          type="button"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Đóng
        </Button>
      </Group>
    </Box>
  );
};

export default React.memo(ItemTechnicalCommonCommand);
